import { render, staticRenderFns } from "./PasswordForgot.vue?vue&type=template&id=fa781e9c&scoped=true&"
import script from "./PasswordForgot.vue?vue&type=script&lang=js&"
export * from "./PasswordForgot.vue?vue&type=script&lang=js&"
import style0 from "./PasswordForgot.vue?vue&type=style&index=0&id=fa781e9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa781e9c",
  null
  
)

export default component.exports